import { Controller } from "@hotwired/stimulus"

// Editor-style section switcher for the Settings page: show ONE section at a
// time (chosen in the left rail) instead of one long scroll. The choice is
// remembered in the URL hash so a refresh / deep-link lands on the same
// section. If this controller never connects, every section just renders (the
// old scrollable page) — a safe fallback.
export default class extends Controller {
  static targets = ["link", "content"]

  connect() {
    this.sections = Array.from(this.contentTarget.querySelectorAll("[data-settings-section]"))
    const wanted = (location.hash || "").replace(/^#/, "")
    this._activate(this._keys().includes(wanted) ? wanted : this._firstKey(), { scroll: false })
  }

  show(event) {
    const key = event.currentTarget.dataset.section
    if (key) this._activate(key)
  }

  _activate(key, { scroll = true } = {}) {
    this.sections.forEach(s => { s.hidden = s.dataset.settingsSection !== key })
    this.linkTargets.forEach(l => l.classList.toggle("is-active", l.dataset.section === key))
    try { history.replaceState(null, "", "#" + key) } catch (_) { /* ignore */ }
    if (scroll) window.scrollTo({ top: 0 })
  }

  _keys() { return this.sections.map(s => s.dataset.settingsSection) }
  _firstKey() { return this._keys()[0] || "branding" }
}
